// extracted by mini-css-extract-plugin
export default {"footerIconify":"Footer_footerIconify__pdwUJ"};